// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"8bc35036","454":"bd02a037","750":"07ec46b2","945":"57bc624a"}[chunkId] + ".chunk.js";
};